"use strict";

var _classCallCheck = require("/root/workspace/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/workspace/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/workspace/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/workspace/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/workspace/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_state_1 = require("prosemirror-state");

var prosemirror_inputrules_1 = require("prosemirror-inputrules");

var prosemirror_view_1 = require("prosemirror-view");

var prosemirror_utils_1 = require("prosemirror-utils");

var Extension_1 = __importDefault(require("../lib/Extension"));

var MAX_MATCH = 500;
var OPEN_REGEX = /^\/(\w+)?$/;
var CLOSE_REGEX = /(^(?!\/(\w+)?)(.*)$|^\/((\w+)\s.*|\s)$)/;

function run(view, from, to, regex, handler) {
  if (view.composing) {
    return false;
  }

  var state = view.state;
  var $from = state.doc.resolve(from);

  if ($from.parent.type.spec.code) {
    return false;
  }

  var textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - MAX_MATCH), $from.parentOffset, null, "\uFFFC");
  var match = regex.exec(textBefore);
  var tr = handler(state, match, match ? from - match[0].length : from, to);
  if (!tr) return false;
  return true;
}

var BlockMenuTrigger = /*#__PURE__*/function (_Extension_1$default) {
  _inherits(BlockMenuTrigger, _Extension_1$default);

  var _super = _createSuper(BlockMenuTrigger);

  function BlockMenuTrigger() {
    _classCallCheck(this, BlockMenuTrigger);

    return _super.apply(this, arguments);
  }

  _createClass(BlockMenuTrigger, [{
    key: "inputRules",
    value: function inputRules() {
      var _this = this;

      return [new prosemirror_inputrules_1.InputRule(OPEN_REGEX, function (state, match) {
        if (match && state.selection.$from.parent.type.name === "paragraph") {
          _this.options.onOpen(match[1]);
        }

        return null;
      }), new prosemirror_inputrules_1.InputRule(CLOSE_REGEX, function (state, match) {
        if (match) {
          _this.options.onClose();
        }

        return null;
      })];
    }
  }, {
    key: "name",
    get: function get() {
      return "blockmenu";
    }
  }, {
    key: "plugins",
    get: function get() {
      var _this2 = this;

      return [new prosemirror_state_1.Plugin({
        props: {
          handleClick: function handleClick() {
            _this2.options.onClose();

            return false;
          },
          handleKeyDown: function handleKeyDown(view, event) {
            if (event.key === "Backspace") {
              setTimeout(function () {
                var pos = view.state.selection.$from.pos;
                return run(view, pos, pos, OPEN_REGEX, function (state, match) {
                  if (match) {
                    _this2.options.onOpen(match[1]);
                  } else {
                    _this2.options.onClose();
                  }

                  return null;
                });
              });
            }

            if (event.key === "Enter" || event.key === "ArrowUp" || event.key === "ArrowDown" || event.key === "Tab") {
              var pos = view.state.selection.$from.pos;
              return run(view, pos, pos, OPEN_REGEX, function (state, match) {
                return match ? true : null;
              });
            }

            return false;
          },
          decorations: function decorations(state) {
            var parent = prosemirror_utils_1.findParentNode(function (node) {
              return node.type.name === "paragraph";
            })(state.selection);

            if (!parent) {
              return;
            }

            var decorations = [];
            var isEmpty = parent && parent.node.content.size === 0;
            var isSlash = parent && parent.node.textContent === "/";
            var isTopLevel = state.selection.$from.depth === 1;

            if (isTopLevel) {
              if (isEmpty) {
                decorations.push(prosemirror_view_1.Decoration.widget(parent.pos, function () {
                  var icon = document.createElement("button");
                  icon.type = "button";
                  icon.className = "block-menu-trigger";
                  icon.innerText = "+";
                  icon.addEventListener("click", function () {
                    _this2.options.onOpen("");
                  });
                  return icon;
                }));
                decorations.push(prosemirror_view_1.Decoration.node(parent.pos, parent.pos + parent.node.nodeSize, {
                  class: "placeholder",
                  "data-empty-text": _this2.options.dictionary.newLineEmpty
                }));
              }

              if (isSlash) {
                decorations.push(prosemirror_view_1.Decoration.node(parent.pos, parent.pos + parent.node.nodeSize, {
                  class: "placeholder",
                  "data-empty-text": "  ".concat(_this2.options.dictionary.newLineWithSlash)
                }));
              }

              return prosemirror_view_1.DecorationSet.create(state.doc, decorations);
            }

            return;
          }
        }
      })];
    }
  }]);

  return BlockMenuTrigger;
}(Extension_1.default);

exports.default = BlockMenuTrigger;